import { memo, useMemo } from 'react';
import { Link } from 'react-router';
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { SubRoute } from './types';
import { getListItemTextStyles } from './styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface Props extends SubRoute {
  expandedView: boolean;
  onClick?: () => void;
}

function NavSubItemBase({ to, isActive, title, expandedView, external, href, onClick }: Props) {
  const listItemButtonStyles = useMemo(() => getNavSubListItemButtonStyles(), []);
  const listItemDividerStyles = useMemo(() => getNavSubListItemDividerStyles(isActive), [isActive]);
  const listItemTextStyles = useMemo(() => getListItemTextStyles(expandedView), [expandedView]);

  return (
    <ListItem disablePadding>
      <ListItemButton
        to={to}
        href={href}
        component={external ? 'a' : Link}
        onClick={onClick}
        selected={isActive}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
        sx={listItemButtonStyles}
      >
        <Divider orientation="vertical" sx={listItemDividerStyles} />

        <ListItemText
          disableTypography
          primary={
            <Typography
              sx={{
                fontWeight: isActive ? 800 : 500,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                gap: 1,
              }}
            >
              {title} {external && <OpenInNewIcon fontSize="small" />}
            </Typography>
          }
          sx={listItemTextStyles}
        />
      </ListItemButton>
    </ListItem>
  );
}

export const NavSubItem = memo(NavSubItemBase);

export const getNavSubListItemButtonStyles = (): SxProps<Theme> => ({
  height: '40px',
  color: (theme) => theme.palette.grey.A400,
  backgroundColor: 'transparent !important',
  padding: 0,
});

export const getNavSubListItemDividerStyles = (isActive: boolean): SxProps<Theme> => ({
  borderColor: (theme) => (isActive ? theme.palette.grey.A400 : theme.palette.grey[100]),
  borderRightWidth: 2,
});
